<template>
    <div >
        <ly-dialog v-model="dialogVisible" :title="loadingTitle" width="1400px" :before-close="handleClose">
          
    <el-row style="margin-top: -20px;">  


    <el-col :span="16"> 

        <el-row style="margin-top: -10px; display: flex;justify-content: space-between;">
            <el-form-item label="开始时间：">  
                <el-date-picker  style="width:200px;height: 25px;"  v-model="startDate"  type="date"  @change="startTimeChange"  ></el-date-picker>  
            </el-form-item>  

            <el-form-item label="&nbsp&nbsp结束时间：">  
                <el-date-picker  style="width:200px;height: 25px;"  v-model="endDate"  type="date"  @change="endTimeChange"  ></el-date-picker>  
            </el-form-item>

            <el-button @click="handleQuery"  style="width: 100px; margin-left: 40px;height: 25px;"  type="primary" >查询</el-button>
            <!-- <el-button v-else @click="handleQuery"  style="width: 100px; margin-left: 40px;height: 25px;"  type="primary" >电流查询</el-button> -->
        </el-row>

        <div v-if="this.alarmInfo.sensor_type == 1">
            <el-row style="margin-bottom:15px;margin-top: -12px;" :style="{ display: this.alarmInfo.type == 1001 ? 'none' : 'block'}">
                <el-col :span="24" style="height: 130px;">
                    <div  ref="lyechartmain" style="height: 100%;width: 100%;"></div>
                </el-col>
            </el-row>

            <el-row style="margin-bottom:15px;margin-top: -10px;" :style="{ display: this.alarmInfo.type == 1001 ? 'none' : 'block'}">
                <el-col :span="24" style="height: 130px;">
                    <div  ref="AccIntensitychartmain" style="height: 100%;width: 100%;"></div>
                </el-col>
            </el-row>

            <el-row style="margin-bottom:15px;margin-top: -10px;" >
                <el-col :span="24" style="height: 130px;">
                    <div  ref="temperatureChartMain" style="height: 100%;width: 100%;"></div>
                </el-col> 
            </el-row>

            <el-row style="margin-bottom:15px;margin-top: -10px;" :style="{ display: this.alarmInfo.type == 1001 ? 'none' : 'block'}">
                <el-col :span="24" style="height: 130px;">
                    <div  ref="xyzChartMain" style="height: 100%;width: 100%;"></div>
                </el-col>
            </el-row>

            <el-row style="margin-bottom:15px;margin-top: -10px;" :style="{ display: this.alarmInfo.type == 1001 ? 'none' : 'block'}">
                <el-col :span="24" style="height: 130px;">
                    <div  ref="hzChartMain" style="height: 100%;width: 100%;"></div>
                </el-col> 
            </el-row>
        </div>
        <div v-if="this.alarmInfo.sensor_type == 2 && this.alarmInfo.type != 1001 ">
            <el-row style="margin-bottom:15px;margin-top: -10px;">
                <el-col :span="24" style="height: 200px;">
                    <div  ref="currentChartMain" style="height: 100%;width: 100%;"></div>
                </el-col> 
            </el-row>
        </div>
        <!-- <div v-if="this.alarmInfo.sensor_type == 1 && this.alarmInfo.type == 1001 ">
            <el-row style="margin-bottom:15px;margin-top: -10px;">
                <el-col :span="24" style="height: 130px;">
                    <div  ref="temperatureChartMain" style="height: 100%;width: 100%;"></div>
                </el-col> 
            </el-row>
        </div> -->

    </el-col>  

    <el-col :span="8"> 
        <el-row style="margin-top: -10px;display: block;">

                <p class="p-top-style">告警详情</p>
                <p class="p-style">设备名称：{{ alarmInfo.device_name }}</p>
                <p class="p-style">设备型号：{{ devinfo.model }}</p>
                <p class="p-style">设备位号：{{ devinfo.psn }}</p>
                <p class="p-style">设备功率(Kw)：{{ (devinfo.power/1000).toFixed(2) }}</p>
                <p class="p-style">设备转速(转/分钟)：{{ devinfo.speed }}</p>
                <p class="p-style">报警类型：{{ alarmInfo.transform_method }}</p>
                <p class="p-style">告警时间：{{ alarmInfo.time }}</p>
                <p class="p-style">故障ID&nbsp&nbsp&nbsp：{{ alarmInfo.fault_id }}</p>
                <p class="p-style">故障类型：{{ alarmInfo.transform_type }}</p>
                <p class="p-style">报警等级：{{ alarmInfo.transform_level }}</p>
                <p class="p-style">报警测点：{{ deviceInfo.sn_location }}</p>
                <!-- <p class="p-style">故障描述：{{ alarmInfo.desc }}</p>
                <p class="p-style">排查建议：{{ alarmInfo.suggestion }}</p> -->
        </el-row>

        <el-row style="margin-bottom: 10px;"> 
            <el-col :span="8">
                <p class="p-style">故障描述：</p>
            </el-col>
            <el-col :span="16">
                <!-- <p style="margin-left: -30px;margin-top: 5px;">AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA</p> -->
                <!-- <el-textarea style="margin-left: -30px; border: none; box-shadow: none; outline: none;" :rows="2" placeholder="无" v-model="alarmInfo.desc" > </el-textarea> -->
                <el-input style="margin-left: -40px; font-size: 12px;margin-top: 5px;"  type="textarea" :rows="2" placeholder="无" v-model="alarmInfo.desc" readonly> </el-input>
            </el-col>

        </el-row>
        
        <el-row>
            <el-col :span="8">
                <p class="p-style">排查建议:</p>
            </el-col>
            <el-col :span="16">
                <!-- <p  style="margin-left: -30px;margin-top: 5px;">AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA</p> -->
                <el-input style="margin-left: -40px; font-size: 12px;width: 300px;margin-top: 5px;" type="textarea" :rows="2" placeholder="无" v-model="alarmInfo.suggestion" readonly> </el-input>
            </el-col>
        </el-row>


        <el-row>
            <el-row style="margin-top: 20px;">
                <p class="p-top-style">告警处理</p>
            </el-row>

            <el-row style="margin-top: -5px;">
                <el-col :span="24" style="display: flex; justify-content: center;">
                    <el-form>
                        <el-form-item style="width: 100%;">
                            <el-radio-group v-model="selectedOption">
                            <el-radio :label="1" style="font-size: 10px;padding-left: 50px;">忽略告警</el-radio>
                            <el-radio :label="2" style="font-size: 10px;padding-left: 5px;">确认告警</el-radio>
                            <el-radio :label="3" style="font-size: 10px;padding-left: 5px;">误报解除</el-radio>
                            <el-radio :label="4" style="font-size: 10px;padding-left: 5px;">重新定义故障</el-radio>
                        </el-radio-group>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>

            <el-row >
                <el-col :span="24" style="margin-left: 55px;margin-top: -15px;color: white;">
                    <el-form :model="form" :rules="rules" ref="form" style="color:white">
                        <el-form-item label="故障类型：" prop="faultType" style="color:red" >
                            <el-select v-model="form.faultType" :placeholder="isDisabledSelectText" size="default" clearable style="width:300px" :disabled="isDisabledSelect">
                            <el-option v-for="item in faultTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item :label="faultOrNormalDescription"  style="margin-top: -15px;">
                            <el-input v-model="form.faultOrNormalDescription"  style="width:300px;margin-left: 10px;" maxlength="199" type="textarea" :rows="2" placeholder="请输入相关说明"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>

                 <el-col :span="24" style="text-align: center; height: 30px;margin-top: -10px;">
                    <el-button style="width: 90px;height: 25px;" type="primary" @click="submitData">确认处理</el-button>
                </el-col>

            </el-row>


            <el-row style="margin-top: 15px;"> 
                <el-col :span="24">
                    <p class="p-style-1">检维修处理方式</p>
                </el-col>

                <el-col :span="24">
                    <el-input style="margin-left: 55px;margin-top: 5px;width:381px;" type="textarea" :rows="1" placeholder="请输入" v-model="maintenance_desc"> </el-input>
                </el-col>

                <el-col :span="24" style="display: flex; justify-content: center;margin-top: 10px;">
                    <el-button style="width: 90px;height: 25px;" type="primary" @click="submitProcessingMethods">提交处理方式</el-button>
                </el-col>
            </el-row>


            <el-col :span="24" style="margin-top: 15px;">
                <p class="p-style-1">故障诊断报告</p>
            </el-col>
 


            <el-row style="margin-top: 10px;margin-left: auto;margin-right: auto;">
                <el-col :span="12" >
                    <el-button style="width: 90px;height: 25px;" type="primary" @click="handledownload">预览&下载</el-button>
                </el-col>    

                <el-col :span="12">
                    <el-upload
                        v-if="roleValue==0 "
                        action=""
                        :show-file-list="false"
                        ref="uploadPdf"
                        :http-request="pdfUploadRequest"
                        :on-success="pdfUploadSuccess"
                        :before-upload="pdfBeforeUpload">
                        <el-button v-if="roleValue==0" type="primary"  style="width: 90px;height: 25px;margin-left: 50px;">上传</el-button>
                     </el-upload>
                </el-col>
            </el-row>



        </el-row>

    </el-col>  
    </el-row> 

    <el-row style="display: flex; justify-content: center; align-items: center;margin-top: -5px;margin-bottom: -10px;">
        <el-button  @click="handleClose"  style="width: 80px;height: 25px;"  type="primary" >退出</el-button> 
    </el-row>


        </ly-dialog>
    </div>

   

</template>

<script>
    import {apiSensorDataHistory,apiAlarmsData,
            apiAlgSpeedSpectrum,apiSensorlist,
            apiAlarmsUpdata,apiAlarmsById,
            apiUploadPdf,apiDevice} from "@/api/api";
    import LyDialog from "@/components/dialog/dialog";
   
    import {deepClone,getStorage} from "@/utils/util";

    //import echarts from 'echarts';
    // import echarts from "@/components/analysis/echartsInstall";
    import * as echarts from 'echarts';

    import {url} from '@/api/url';
   

   


// import { apiUploadPdf } from "../../api/api";

    export default {
        components: {LyDialog},
        name: "faultInfo",
        emits: ['handleInfo'],
        // setup(){
        //     const mutitabsstore = useMutitabsStore()
        //     const roleValue = mutitabsstore.getRole;
        //     return {roleValue};
        //     // return { mutitabsstore}
        // },
        watch: {
            selectedOption(newValue) {
                if (newValue === 4) {
                    this.isDisabledSelect = false;
                    this.isDisabledSelectText = "请选择"
                    this.faultOrNormalDescription = "故障说明:"
                    if(this.alarmInfo.processed_type == 0 || this.alarmInfo.processed_type == null)
                        this.form.faultType = null
                    else
                        this.form.faultType = this.alarmInfo.processed_type
                } else {
                    this.isDisabledSelect = true;
                    this.isDisabledSelectText = "不可选"
                    this.form.faultType = null
                    this.faultOrNormalDescription = "处理说明:"
                }
                this.form.faultOrNormalDescription = this.alarmInfo.processed_desc
            }
        },
        data() {
            const xyzChart_length = 1000;
            const xyzChart_seg_duration = 2;
            return {
                roleValue : -1,
                maintenance_desc:"",
                isDisabledSelect:true,
                isDisabledSelectText:"不可选",
                faultOrNormalDescription : "处理说明:",
                selectedOption:null,
                form : {
                    faultType : null,
                    faultOrNormalDescription : null
                },
               
                rules: {  
                    faultType: [  
                        { required: this.isDisabledSelect , message: '请选择一个选项', trigger: 'change' }  
                    ],
                    // faultDescription: [
                    //     {required: true, message: '请输入相关描述',trigger: 'blur'}
                    // ],  
                } ,
                faultTypeList:[
                    {id:0,name:'空'},
                    {id:1,name:'停机'},
                    {id:99,name:'其他故障'},
                    {id:100,name:'模拟事件'},
                    {id:101,name:'转子不对中'},
                    {id:102,name:'转子不平衡'},
                    {id:103,name:'轴弯曲'},
                    {id:104,name:'轴裂纹'},
                    {id:105,name:'轴承松动'},
                    {id:106,name:'滚动轴承故障'},
                    {id:107,name:'滑动轴承故障'},
                    {id:201,name:'UPS温度过高'},
                    {id:202,name:'UPS电源局部放电'},
                    {id:203,name:'UPS电源机械性故障'},
                    {id:301,name:'空调压缩机故障'},
                    {id:401,name:'变压器局部放电'},
                    {id:402,name:'变压器绕组形变'},
                    {id:403,name:'变压器部件松动'},
                    {id:404,name:'变压器直流偏磁'},
                    {id:901,name:'电流异常'},
                    {id:1001,name:'温度异常'},
                ],
                dialogVisible:false,
                loadingTitle:'',

                myChart: null,
                lyechartmain: null,
                option: { 
                    backgroundColor: 'rgba(48, 56, 127, 0.8)',
                    grid: {  
				        left: '2%',  
				        right: '2%', 
				        top: '20%',   
				        bottom: '5%', 
				        containLabel: true 
				    },
                    // 鼠标放上去显示振动烈度的数值
                    tooltip:{
                        trigger: 'axis',
                        axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#180287'
                        }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data:[],
                        axisLabel: { 
                            color: '#ffffff', 
                            fontSize: 10,
                        },
                    },
                    yAxis: {
                        show: true,
                        name:"振动烈度 mm/s",
                        nameTextStyle: {  
                            color: '#FFFFFF',
                            padding: [0, 0, -8, 80],
                            fontSize: 12,
			            },
                        position: 'left',
                        type: 'value',
                        // axisLine: {  
                        //     show: true  
                        // },
                        axisLine: {
                            show: true,
                            // lineStyle: {
                            //     color: 'red',
                            //     width: 10,
                            //     type: 'solid'
                            // },
                            // onZero: true,
                            // symbol: 'arrow'
                        },
                        axisTick: {  
                            show: true,
                            // length:0 
                        },
                        axisLabel: { 
                            color: '#ffffff',
                            fontSize: 10,
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                shadowBlur: 0,
                                shadowOffsetX:0,
                                shadowOffsetY:0,
                                opacity:0
                            }
                        },
                        splitLine: {
                            show:true, 
                            lineStyle: {
                                type: "dotted",
                                width: 1,
                                color: 'rgba(100, 100, 100, 0.8)', 
                                dashOffset: 10 ,
                            }
                        }
                    },
                    color: ['#268AFF'],
                    series: [
                    {  
                        data:[],
                        type: 'line', // 曲线图类型
                        // smooth: false, 
                        // symbol: 'circle', // 将标记点指定为圆形
                        // showSymbol: true,
                        symbol: 'circle',
                        symbolSize: 0,
                        // itemStyle: {
                        //     borderWidth: 00,
                        //     borderColor: '#EE6666',
                        //     color: 'yellow'
                        // }
                    }
                    ]
                },
                myAccIntensityChart: null,
                AccIntensitychartmain: null,
                AccIntensityOption: { 
                    backgroundColor: 'rgba(48, 56, 127, 0.8)',
                    grid: {  
				        left: '2%',  
				        right: '2%', 
				        top: '20%',   
				        bottom: '5%', 
				        containLabel: true 
				    },
                    tooltip:{
                        trigger: 'axis',
                        axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#180287'
                        }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data:[],
                        axisLabel: { 
                            color: '#ffffff', 
                            fontSize: 10,
                        },
                    },
                    yAxis: {
                        show: true,
                        name:"加速度烈度 m²/s",
                        nameTextStyle: {  
                            color: '#FFFFFF',
                            padding: [0, 0, -8, 95],
                            fontSize: 12,
			            },
                        position: 'left',
                        type: 'value',
                        axisLine: {
                            show: true,
                        },
                        axisTick: {  
                            show: true,
                        },
                        axisLabel: { 
                            color: '#ffffff',
                            fontSize: 10,
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                shadowBlur: 0,
                                shadowOffsetX:0,
                                shadowOffsetY:0,
                                opacity:0
                            }
                        },
                        splitLine: {
                            show:true, 
                            lineStyle: {
                                type: "dotted",
                                width: 1,
                                color: 'rgba(100, 100, 100, 0.8)', 
                                dashOffset: 10 ,
                            }
                        }
                    },
                    color: ['#268AFF'],
                    series: [
                    {  
                        data:[],
                        type: 'line', // 曲线图类型
                        symbol: 'circle',
                        symbolSize: 0,
                    }
                    ]
                },
                

                xyzChart:null,
                xyzChartMain:null,
                xyzOption: { 
				backgroundColor: 'rgba(48, 56, 127, 0.8)', 
				  grid: {  
				        left: '2%',  
				        right: '2%', 
				        top: '20%',   
				        bottom: '5%', 
				        containLabel: true 
				    },
                    tooltip:{
                        trigger: 'axis',
                        axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#180287'
                        }
                        }
                    },
			    // legend: {
			    //     data: ['健康','故障'],
			    //     icon: 'rect',
			    //     itemWidth: 10,
			    //     itemHeight: 10,
			    //     top: '4%',
			    //     right: 5,
			    //     left: '73%',
			    //     selectedMode: false,  // 取消图例的点击事件
			    //     textStyle: {
			    //         fontSize: 12,
			    //         color: '#ffffff'
			    //     }
			    // },
			    xAxis: {
			        type: 'category',
			        data: Array(xyzChart_length/xyzChart_seg_duration).fill().map((_, i) => i + 1),
			        axisLabel: { 
			            color: '#ffffff', 
						fontSize: 10,
			        },
			    },
			    yAxis: {
			        show: true,
			        name:"Z轴加速度 m²/s",
			        nameTextStyle: {  
			            color: '#FFFFFF',
						padding: [0, 0, -8, 85],
						fontSize: 12,
			        },
			        position: 'left',
			        type: 'value',
			        axisLine: {
			            show: true,
			        },
			        axisTick: {  
			            show: true,
			        },
			        axisLabel: { 
			            color: '#ffffff',
						fontSize: 10,
			        },
			        splitArea: {
			            show: true,
			            areaStyle: {
			                shadowBlur: 0,
			                shadowOffsetX:0,
			                shadowOffsetY:0,
			                opacity:0
			            }
			        },
			        splitLine: {
			            show:true, 
			            lineStyle: {
							width: 1, 
							type: "dotted",  
                            color: 'rgba(100, 100, 100, 0.8)', 
                            dashOffset: 10 ,
			            }
			        }
			    },
			    color: ['#268AFF'],
			    series: [
			  
                    {  
                        data:[],
                        type: 'line', // 曲线图类型
                        symbol: 'circle',
                        symbolSize: 0,
                    }
			      ]
			    },
			    xyzChart_length:xyzChart_length,
                xyzChart_seg_duration:xyzChart_seg_duration,


                hzChart:null,
                hzChartMain:null,
                hz_option: {
				backgroundColor: 'rgba(48, 56, 127, 0.8)', 
				  grid: {  
				        left: '2%',    
				        right: '2%',   
				        top: '20%',   
				        bottom: '5%',
				        containLabel: true 
				    },
                    tooltip:{
                        trigger: 'axis',
                        axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#180287'
                        }
                        }
                    },
				// legend: {
				//     data: ['健康','故障'],
				//     icon: 'rect',
				//     itemWidth: 10,
				//     itemHeight: 10,
				//     top: '4%',
				//     right: 5,
				//     left: '73%',
				//     selectedMode: false,  // 取消图例的点击事件
				//     textStyle: {
				//         fontSize: 12,
				//         color: '#ffffff'
				//     }
				// },
			    xAxis: {
			        type: 'category',
			  			data:[],
			        axisLabel: { 
			            color: '#ffffff', 
                        fontSize: 10,
			        },
			    },
			    yAxis: {
			        show: true,
			        name:"频谱图 um/s",
                    nameTextStyle: {  
			            color: '#FFFFFF',
						padding: [0, 0, -8, 75],
						fontSize: 12,
			        },
			        position: 'left',
			        type: 'value',
			        axisLine: {
			            show: true,
			        },
			        axisTick: {  
			            show: true,
			            // length:0 
			        },
			        axisLabel: { 
			            color: '#ffffff',
                        fontSize: 10,
                        formatter: function(value) {
                         // 假设 value 是一个数字，我们将其转换为字符串并保留一位小数
                            return parseFloat(value).toFixed(1);
                        }
			        },
			        splitArea: {
			            show: true,
			            areaStyle: {
			                shadowBlur: 0,
			                shadowOffsetX:0,
			                shadowOffsetY:0,
			                opacity:0
			            }
			        },
			        splitLine: {
			            show:true, 
			            lineStyle: {
			  				color: 'rgba(100, 100, 100, 0.8)', 
                            dashOffset: 10 ,
			  				width: 1, 
			  				type: "dotted",  
			            }
			        }
			    },
			    color: ['#268AFF'],
			    series: [
			  	    // {
			  	    //     name: '故障',
			  	    //     data: [],
			  	    //     type: 'line', // 曲线图类型
			  	    //     symbol: 'circle',
			  	    //     symbolSize: 0,
			  	    //     lineStyle: {  
			  	    //       color: 'rgba(199, 0, 0, 1)', // 这里设置了透明度为 0.5 的颜色  
			  	    //     }, 
			  	    // },
			  	    // {  
			  	    //     name: '健康',
			  	    //     data: [],
			  	    //     type: 'line', // 曲线图类型
			  	    //     symbol: 'circle',
			  	    //     symbolSize: 0,
			  	    //     lineStyle: {  
			  	    //       color: 'rgba(0, 255, 255, 0.5)', // 这里设置了透明度为 0.5 的颜色  
			  	    //     }, 
			  	    // },
                    {  
                        data:[],
                        type: 'line', // 曲线图类型
                        symbol: 'circle',
                        symbolSize: 0,
                    }
			    ]
			    },

                myTemperatureChart: null,
                temperatureChartmain: null,
                temperatureOption: { 
                    backgroundColor: 'rgba(48, 56, 127, 0.8)',
                    grid: {  
				        left: '2%',  
				        right: '2%', 
				        top: '20%',   
				        bottom: '5%', 
				        containLabel: true 
				    },
                    tooltip:{
                        trigger: 'axis',
                        axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#180287'
                        }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data:[],
                        axisLabel: { 
                            color: '#ffffff', 
                            fontSize: 10,
                        },
                    },
                    yAxis: {
                        show: true,
                        name:"温度 °C",
                        nameTextStyle: {  
                            color: '#FFFFFF',
                            padding: [0, 0, -8, 40],
                            fontSize: 12,
			            },
                        position: 'left',
                        type: 'value',
                        axisLine: {
                            show: true,
                        },
                        axisTick: {  
                            show: true,
                        },
                        axisLabel: { 
                            color: '#ffffff',
                            fontSize: 10,
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                shadowBlur: 0,
                                shadowOffsetX:0,
                                shadowOffsetY:0,
                                opacity:0
                            }
                        },
                        splitLine: {
                            show:true, 
                            lineStyle: {
                                type: "dotted",
                                width: 1,
                                color: 'rgba(100, 100, 100, 0.8)', 
                                dashOffset: 10 ,
                            }
                        }
                    },
                    color: ['#268AFF'],
                    series: [
                    {  
                        data:[],
                        type: 'line', // 曲线图类型
                        symbol: 'circle',
                        symbolSize: 0,
                    }
                    ]
                },

                myCurrentChart: null,
                currentChartmain: null,
                currentOption: { 
                    backgroundColor: 'rgba(48, 56, 127, 0.8)',
                    grid: {  
				        left: '2%',  
				        right: '2%', 
				        top: '20%',   
				        bottom: '5%', 
				        containLabel: true 
				    },
                    tooltip:{
                        trigger: 'axis',
                        axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#180287'
                        }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data:[],
                        axisLabel: { 
                            color: '#ffffff', 
                            fontSize: 10,
                        },
                    },
                    yAxis: {
                        show: true,
                        name:"电流 A",
                        nameTextStyle: {  
                            color: '#FFFFFF',
                            padding: [0, 0, -8, 40],
                            fontSize: 12,
			            },
                        position: 'left',
                        type: 'value',
                        axisLine: {
                            show: true,
                        },
                        axisTick: {  
                            show: true,
                        },
                        axisLabel: { 
                            color: '#ffffff',
                            fontSize: 10,
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                shadowBlur: 0,
                                shadowOffsetX:0,
                                shadowOffsetY:0,
                                opacity:0
                            }
                        },
                        splitLine: {
                            show:true, 
                            lineStyle: {
                                type: "dotted",
                                width: 1,
                                color: 'rgba(100, 100, 100, 0.8)', 
                                dashOffset: 10 ,
                            }
                        }
                    },
                    color: ['#268AFF'],
                    series: [
                    {  
                        data:[],
                        type: 'line', // 曲线图类型
                        symbol: 'circle',
                        symbolSize: 0,
                    }
                    ]
                },


                alarmInfo:{},
                devinfo:{},
                userName:"",

                startDate:"",
                endDate:"",
                QueryChartDate:{
                    flag:false,
                    time_before:"",
                    time_after:"",
                },

                deviceInfo:{
                    sn_location:"",
                },

                alarmInfoChangeFlag:false,
            }
        },
        methods:{
            async handleQuery(){
                if(this.startDate == "" || this.endDate == "" || this.startDate == null || this.endDate == null ){
                    this.$message.warning("查询错误：请检查时间设置！")
                    return
                }
                
                const end = new Date(this.endDate)
                const endStr = `${end.getFullYear()}-${(end.getMonth() + 1).toString().padStart(2, '0')}-${end.getDate().toString().padStart(2, '0')} 00:00:00`
                const start = new Date(this.startDate)
                const startStr = `${start.getFullYear()}-${(start.getMonth() + 1).toString().padStart(2, '0')}-${start.getDate().toString().padStart(2, '0')} 00:00:00`
                
                this.QueryChartDate.flag = true
                this.QueryChartDate.time_after = endStr
                this.QueryChartDate.time_before = startStr

                this.option.series[0].data = []
                this.option.xAxis.data = []
                this.AccIntensityOption.series[0].data = []
                this.AccIntensityOption.xAxis.data = []
                this.temperatureOption.series[0].data = []
                this.temperatureOption.xAxis.data = []
                this.currentOption.series[0].data = []
                this.currentOption.xAxis.data = []
                if(this.alarmInfo.sensor_type == 1){
                    this.myChart.setOption(this.option);
                    this.myAccIntensityChart.setOption(this.AccIntensityOption);
                    this.myTemperatureChart.setOption(this.temperatureOption);
                }else{
                    this.myCurrentChart.setOption(this.currentOption);
                }

                await this.getIntensityChartData()

                if(this.alarmInfo.sensor_type == 1){
                    if(this.lyechartmain != null){
                        this.myChart.setOption(this.option);
                    }
                    
                    if(this.AccIntensitychartmain != null){
                        this.myAccIntensityChart.setOption(this.AccIntensityOption);
                    }

                    if(this.temperatureChartmain != null){
                        this.myTemperatureChart.setOption(this.temperatureOption);
                    }else{//奇怪的BUG,变为NULL了
                        this.myTemperatureChart.setOption(this.temperatureOption);
                    }
                }else{
                    if(this.currentChartMain != null){
                        this.myCurrentChart.setOption(this.currentOption);
                    }
                }
            },

            handleClose() {
                this.dialogVisible=false
                if(this.alarmInfoChangeFlag)
                    this.$emit('handleInfo','quit')
            },

           async faultInfoFn(item,flag)  {

                if(item){
                    this.alarmInfo = deepClone(item)
                }
                let fnt = {
                        name_exact : this.alarmInfo.device_name,
                    }
               
                 const devinofget = await apiDevice(fnt)
                
                if(devinofget.status ==200){
                    this.devinfo = devinofget.data.data.items[0]
                      
                }
                            
                
                this.loadingTitle=flag
                this.dialogVisible=true

                this.selectedOption = this.alarmInfo.state    
                this.maintenance_desc = this.alarmInfo.maintenance_desc

                if(this.alarmInfo.desc == ""){
                    this.alarmInfo.desc = "暂无"
                }
                if(this.alarmInfo.suggestion == ""){
                    this.alarmInfo.suggestion = "暂无"
                }
            },

            extractDate(dateString) {  
                const regex = /\d{4}-\d{2}-\d{2}/;  
                const match = dateString.match(regex);  
                return match ? match[0] : "0";  
            },


            SameDateWithFilter(dateStr, items) {  
                const inputDate = new Date(dateStr);  
                const year = inputDate.getFullYear();  
                const month = inputDate.getMonth() + 1; 
                const day = inputDate.getDate();  
            
                return items.filter(item => {  
                    const itemDate = new Date(item.time);  
                    return itemDate.getFullYear() === year &&  
                        itemDate.getMonth() + 1 === month && 
                        itemDate.getDate() === day;  
                }).length;  
            },

            calcStep(total){
                let step = 0
                if(total > 500){
                    step = Math.floor(total / 500) - 1
                }
                return step;
            },

            async getIntensityChartData(){

                const dateString = this.alarmInfo.time;
                let dateArray = []
                if(this.QueryChartDate.flag){
                    dateArray.push(this.QueryChartDate.time_before)
                    dateArray.push(this.QueryChartDate.time_after)
                    this.QueryChartDate.flag = false
                }else{
                    dateArray = this.generateDateArray(dateString);  
                }
                
                this.option.series[0].data = []
                this.option.xAxis.data = []
                this.AccIntensityOption.series[0].data = []
                this.AccIntensityOption.xAxis.data = []
                this.temperatureOption.series[0].data = []
                this.temperatureOption.xAxis.data = []
                this.currentOption.series[0].data = []
                this.currentOption.xAxis.data = []

                this.startDate = dateArray[0].split(" ")[0]
                this.endDate =  dateArray[dateArray.length - 1].split(" ")[0]
                try{
                   
                        var para = {};
                        if(this.alarmInfo.sensor_type==1){
                            para = {
                            sn : this.alarmInfo.sensor_sn,
                            time_after: dateArray[0].split(" ")[0],
                            time_before: dateArray[dateArray.length - 1].split(" ")[0],
                            // downsample: step
                            count : 500
                            }
                        }else{
                            para = {
                            sn : this.alarmInfo.sensor_sn,
                            time_after: dateArray[0].split(" ")[0],
                            time_before: dateArray[dateArray.length - 1].split(" ")[0],
                            // downsample: step
                            count : 500,
                            sensor_type : this.alarmInfo.sensor_type
                            }
                        }
                        const res = await apiSensorDataHistory(para)
                        if(res.data.code == 200){
                            var Xarray= []
                            var Yarray= []
                            var AccIntensityXarray= []
                            var AccIntensityYarray= []
                            var temperatureXarray = []
                            var temperatureYarray = []
                            var currentXarray = []
                            var currentYarray = []
                            const alarm_time = this.alarmInfo.time

                            if(this.alarmInfo.sensor_type == 1){//振动传感器
                                for(let i = 0; i<res.data.data.items.length; i++){
                                    var yValue = 0.0
                                    var temperatureyValue = 0.0
                                    var xValue =null
                                 
                                    if(para.time_after.split('-')[0] != para.time_before.split('-')[0]){
                                        xValue = res.data.data.items[i].time.split(" ")[0]
                                    }
                                    else  {
                                        const result_time = res.data.data.items[i].time
                                        var parts = result_time.replace(/^\d{4}-(\d{2}-\d{2}) (\d{2}:\d{2}):\d{2}$/,"$1 $2");
                                    
                                        xValue = parts;
                                    }
                                    if(res.data.data.items[i].alarm_type <901){
                                        if(alarm_time ==  res.data.data.items[i].time){
                                       
                                       var yValueObj = {
                                           value:res.data.data.items[i].intensity,
                                           symbol:"circle",
                                           symbolSize:10,
                                           itemStyle:{color: "red"}
                                       }
                                      
                                       Yarray.push(yValueObj)
                                      
                                   }else{
                                       yValue  = res.data.data.items[i].intensity
                                     
                                       Yarray.push(yValue)
                                       
                                   }

                                    }
                                   
                                 
                                    if(alarm_time ==  res.data.data.items[i].time && res.data.data.items[i].alarm_type ==1001){
                                        var temperatureyValueObj ={
                                            value:res.data.data.items[i].temperature,
                                            symbol:"circle",
                                            symbolSize:10,
                                            itemStyle:{color: "red"}
                                           }
                                           
                                           temperatureYarray.push(temperatureyValueObj)
                                    }else{
                                       
                                        temperatureyValue = res.data.data.items[i].temperature
                                        temperatureYarray.push(temperatureyValue)
                                    }

                                    
                                   

                                    Xarray.push(xValue)
                                    temperatureXarray.push(xValue)

                                    AccIntensityYarray.push(res.data.data.items[i].aspeed_intensity)
                                    AccIntensityXarray.push(xValue)

                                 
                                   
                                } 

                                //XY轴最后补两个空数据
                                var lastItem = Xarray[Xarray.length - 1]
                                Xarray.push(lastItem)
                                Xarray.push(lastItem)
                                Yarray.push(null)
                                Yarray.push(null)
                                this.option.xAxis.data = Xarray
                                this.option.series[0].data = Yarray

                                AccIntensityXarray.push(lastItem)
                                AccIntensityXarray.push(lastItem)
                                AccIntensityYarray.push(null)
                                AccIntensityYarray.push(null)
                                this.AccIntensityOption.xAxis.data = AccIntensityXarray
                                this.AccIntensityOption.series[0].data = AccIntensityYarray

                                temperatureXarray.push(lastItem)
                                temperatureXarray.push(lastItem)
                                temperatureYarray.push(null)
                                temperatureYarray.push(null)
                                this.temperatureOption.xAxis.data = temperatureXarray
                                this.temperatureOption.series[0].data = temperatureYarray

                            }else{//电流传感器

                                for(let i = 0; i<res.data.data.items.length; i++){
                                    var yValue = 0.0
                                    var xValue
                                    if(para.time_after == para.time_before){
                                        var parts = res.data.data.items[i].time.split(" "); 
                                        var timeParts = parts[1].split(":"); 
                                        xValue = timeParts[0] + ":" + timeParts[1];
                                    }else{
                                        xValue = res.data.data.items[i].time.split(" ")[0]
                                    }
                                    if(alarm_time ===  res.data.data.items[i].time){
                                        var yValueObj = {
                                            value:res.data.data.items[i].intensity,
                                            symbol:"circle",
                                            symbolSize:10,
                                            itemStyle:{color: "red"}
                                        }
                                        currentYarray.push(yValueObj)
                                    }else{
                                        yValue  = res.data.data.items[i].intensity
                                        currentYarray.push(yValue)
                                    }
                                    currentXarray.push(xValue)
                                } 

                                //XY轴最后补两个空数据
                                var lastItem = currentXarray[currentXarray.length - 1]
                                currentXarray.push(lastItem)
                                currentXarray.push(lastItem)
                                currentYarray.push(null)
                                currentYarray.push(null)
                                this.currentOption.xAxis.data = currentXarray
                                this.currentOption.series[0].data = currentYarray

                            }


                        }
                    
                    // }

                } catch(error){
                    console.log("apiAlarmsData error")
                    //console.log(error)
                }           
            },

            async getAccChartData(){
                this.xyzOption.series[0].data = []
                // this.xyzOption.series[1].data = []
                this.hz_option.series[0].data = []

				try{					
				  var para_fault_alarmData = {
					 	//  duration : this.xyzChart_length,
					 	//  seg_duration: this.xyzChart_seg_duration,
                         fault_id: this.alarmInfo.fault_id,
						 is_health : false,
                         new_api : true,
                         count : 500
				  }
                  if(this.alarmInfo.type != 1001){
                    const res_fault_alarmData = await apiAlarmsData(para_fault_alarmData)
				  if(res_fault_alarmData.data.code == 200){
					 	 var z_fault_line = []
						 var speedItems = res_fault_alarmData.data.data.wave
						 
					 	 for(let i=0; i<speedItems.length ; i++){
					 			z_fault_line.push(speedItems[i])
					 	 }		
					 	this.xyzOption.series[0].data = z_fault_line
				  }
                  }
				
				} 
                
                catch(error){
                    console.log("apiAlarmsData error")
				    //console.log(error)
				}

			

				try{
					var para_alg = {
							is_health: false,
							fault_id: this.alarmInfo.fault_id,
                            count : 600
							// is_health: true,
							// sensor_sn: "771096",
					}
                    const res_alg = await apiAlgSpeedSpectrum(para_alg)
					if(res_alg.data.code == 200){
						var x_fault_data = []
						var y_fault_data = []
						
						var hzItems = res_alg.data.data.speed_spectrum
						
                            


						if(hzItems != null){
							for(let i = 0; i< hzItems.length ; i+=2){ 
									x_fault_data.push(hzItems[i])
									y_fault_data.push(hzItems[i+1] * 1000)
							}	

                      
                            
							this.hz_option.xAxis.data = x_fault_data
							this.hz_option.series[0].data = y_fault_data								
						}
					}
				} catch(error){
				    console.log(error)
				}	
		

            },

            generateDateArray(dateString) {  

                // var day_befor = -2   //三天数据
                // var day_after = 1
                // if(this.userName === "admin"){
                //     month_befor = -1.5
                //     month_after = 0.5
                // }

                const [year, month, day] = dateString.split(" ")[0].split("-"); 
                const curDate = new Date(year, month - 1, day); 
                // const startDate = new Date(curDate.getTime() + day_befor * 1000 * 60 * 60 * 24); 
                // const endDate = new Date(curDate.getTime() + day_after * 1000 * 60 * 60 * 24); 
                // const finalEndDate = endDate > curDate ? curDate : endDate;
                const startDate = curDate;
                const finalEndDate = curDate; //一天的数据

                const result = [];
                // for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
                //     const year = d.getFullYear();  
                //     const month = String(d.getMonth() + 1).padStart(2, '0');  
                //     const day = String(d.getDate()).padStart(2, '0'); 
                //     for(let i = 0 ; i< 24 * 2 ; i++){
                //         const hour = String(Math.floor(i / 2)).padStart(2, '0');
                //         const sec = String(i%2 * 30).padStart(2, '0');
                //         result.push(`${year}-${month}-${day} ${hour}:${sec}:00`); 
                //     }
                // }
                let yearTmp = startDate.getFullYear();  
                let monthTmp = String(startDate.getMonth() + 1).padStart(2, '0');  
                let dayTmp = String(startDate.getDate()).padStart(2, '0'); 
                result.push(`${yearTmp}-${monthTmp}-${dayTmp} 00:00:00`); 

                yearTmp = finalEndDate.getFullYear();  
                monthTmp = String(finalEndDate.getMonth() + 1).padStart(2, '0');  
                dayTmp = String(finalEndDate.getDate()).padStart(2, '0'); 
                result.push(`${yearTmp}-${monthTmp}-${dayTmp} 00:00:00`); 

                return result;  
            },

            startTimeChange(val){
                if (val) {
                    const start = new Date(val)
                    const today = new Date()
                    const todayIntegralPoint = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                    if(start.getTime() > todayIntegralPoint.getTime()){
                        this.startDate = ""
                        this.$message.warning("查询时间设置错误：超过当前时间！")
                    }else {
                        if(!(this.endDate == "" || this.endDate == null)){
                            const end = new Date(this.endDate)
                            if(start.getTime() > end.getTime()){
                                this.startDate = ""
                                this.$message.warning("查询时间设置错误：开始时间大于结束时间！")
                            }else{
                                const fifteenDaysAgo = new Date(end);
                                fifteenDaysAgo.setDate(end.getDate() - 15);
                                if(start.getTime() <= fifteenDaysAgo.getTime()){
                                    this.startDate = ""
                                    this.$message.warning("查询时间设置错误：最多查询半个月的记录！")
                                }
                            }
                        }
                    }
                }
            },

            endTimeChange(val){
                if (val) {
                    const end = new Date(val)
                    const today = new Date()
                    const todayIntegralPoint = new Date(today.getFullYear(), today.getMonth(), today.getDate());

                    if(end.getTime() > todayIntegralPoint.getTime()){
                        this.endDate = ""
                        this.$message.warning("查询时间设置错误：超过当前时间！")
                    }else {
                        if(!(this.startDate == "" || this.startDate == null)){
                            const start = new Date(this.startDate)
                            if(start.getTime() > end.getTime()){
                                this.endDate = ""
                                this.$message.warning("查询时间设置错误：开始时间大于结束时间！")
                            }else{
                                const fifteenDaysAgo = new Date(end);
                                fifteenDaysAgo.setDate(end.getDate() - 15);
                                if(start.getTime() <= fifteenDaysAgo.getTime()){
                                    this.endDate = ""
                                    this.$message.warning("查询时间设置错误：最多查询半个月的记录！")
                                }
                            }
                        }
                    }
                }
            },


            getDeviceInfo(){
                let fnParm = {
                    sn : this.alarmInfo.sensor_sn
                }
                apiSensorlist(fnParm).then(res => {
                    if(res.data.code ==200) {
                        if(res.data.data.total >= 1){
                            this.deviceInfo.sn_location = res.data.data.items[0].name
                        }else{
                            this.deviceInfo.sn_location = ""
                        }
                    }else{
                        this.deviceInfo.sn_location = ""
                    }
                    }).catch(res => {  
                        this.deviceInfo.sn_location = ""
                });  
            },

            getAlarmsHandleInfo(){
                let alarmId = {
                    id : this.alarmInfo.id
                } 
                apiAlarmsById(alarmId).then(async res => {
                    if (res.code === 200) {
                        console.log(res)
                        // if(res.data.state != 0){
                            
                        //     if(res.data.processed_type == 0 || res.data.processed_type == null)
                        //         this.formSave.faultType = null
                        //     else
                        //         this.formSave.faultType = res.data.processed_type
                        //     this.form.faultDescription = res.data.processed_desc

                        //     this.selectedOption = res.data.state
                        //     this.alarmInfo = res.data
                        // } 
                    } else {
                        this.$message.error(`获取告警信息失败`)
                    }
                }).catch(res => {  
                    this.$message.error(`获取告警信息失败：${res.msg}`)
                }); 
            },

            submitData() {
                console.log(this.selectedOption)
                if( this.selectedOption != null && this.selectedOption != 0)
                {
                    if(this.selectedOption == 4){

                        if(this.form.faultType == null || this.form.faultType == 0){
                            this.$message.warning(`未选择重新定义故障类型`)
                            return
                        }

                        // if(this.form.faultOrNormalDescription == null || this.form.faultOrNormalDescription == ""){
                        //     this.$message.warning(`未填写告警故障说明`)
                        //     return
                        // }

                        this.$refs.form.validate((valid) => {  
                            if (valid) {  

                                var param = {
                                    id : this.alarmInfo.id,
                                    level: this.alarmInfo.level,
                                    state: this.selectedOption,
                                    processed_type: this.form.faultType,
                                    processed_desc: this.form.faultOrNormalDescription
                                }

                                console.log(param)
                                
                                apiAlarmsUpdata(param).then(async res => {
                                    if (res.code === 200) {
                                        // this.handleClose()
                                        // this.$emit('updataConfirm','comfirm')
                                        this.alarmInfoChangeFlag =  true;
                                        this.$message.success("告警处理更新成功！")
                                    } else {
                                        this.$message.error(`告警处理更新失败`)
                                    }
                                }).catch(res => {  
                                    this.$message.error(`告警处理更新失败：${res.msg}`)
                                });                            

                            } 
                        });
                    }else{
                        // if(this.form.faultOrNormalDescription == null || this.form.faultOrNormalDescription == ""){
                        //     this.$message.warning(`未填写告警处理说明`)
                        //     return
                        // }

                        var param = {
                            id : this.alarmInfo.id,
                            level: this.alarmInfo.level,
                            state: this.selectedOption,
                            processed_type: 0,
                            processed_desc: this.form.faultOrNormalDescription,
                        }

                        apiAlarmsUpdata(param).then(async res => {
                            if (res.code === 200) {
                                // this.handleClose()
                                // this.$emit('updataConfirm','comfirm')
                                this.alarmInfoChangeFlag =  true;
                                this.$message.success("告警处理更新成功！")
                            } else {
                                this.$message.error(`告警处理更新失败`)
                            }
                        }).catch(res => {  
                            this.$message.error(`告警处理更新失败：${res.msg}`)
                        }); 

                    }
  
                }else{
                    this.$message.warning(`未选择告警处理方式`)
                }
            },

            submitProcessingMethods(){
                if(this.maintenance_desc == null || this.maintenance_desc == "" ){
                    this.$message.warning(`未填写处理方式`)
                    return
                }

                var param = {
                    id : this.alarmInfo.id,
                    maintenance_desc : this.maintenance_desc
                }

                apiAlarmsUpdata(param).then(async res => {
                    if (res.code === 200) {
                        this.alarmInfoChangeFlag =  true;
                        this.$message.success("检维修处理方式提交成功！")
                    } else {
                        this.$message.error(`检维修处理方式提交失败`)
                    }
                }).catch(res => {  
                    this.$message.error(`检维修处理方式提交失败${res.msg}`)
                }); 
            },

            pdfUploadSuccess() {
                this.$refs.uploadPdf.clearFiles()
            },

            async pdfUploadRequest(param) {
                var vm = this
                let params = {
                    param : param,
                    fault_id : this.alarmInfo.fault_id
                }
                try {
                    let obj = await apiUploadPdf(params);

                    if(obj.code == 200) {
                        this.alarmInfo.report_url = obj.data.report_url
                        this.alarmInfoChangeFlag =  true;
                        this.$message.success("PDF文档上传成功！")
                    }else{
                        this.$message.warning("PDF文档上传失败！")
                    }
                } catch (error) {
                    console.error(error);
                    this.$message.warning(`PDF文档上传失败！`)
                }
            },


            handledownload(){
                let pdf_url = ""
                if( !(this.alarmInfo.report_url == "" || this.alarmInfo.report_url == null) ){
                    var pic_split = this.alarmInfo.report_url.split("//")[1].split("/").slice(1).join("/")
                    pdf_url = url + pic_split

                    window.open(pdf_url, '_blank');
                } else{
                    this.$message.warning(`报告资源不存在！`)
                }
            },

            checkPdf(file) {

                const isPDF = file.type === 'application/pdf';
                const isLt10M = file.size / 1024 / 1024 < 10
                if (!isPDF) {
                    this.$message.error('文件只能是 PDF 格式!');
                    return false;
                }
                if (!isLt10M) {
                    this.$message.error('文件大小不能超过 10MB!');
                    return false;
                }
                return isPDF;
            },

            pdfBeforeUpload(file){
                return this.checkPdf(file)
            },

        },


        async updated() {
            if(this.dialogVisible == true){ 
                this.getDeviceInfo()
                await this.getIntensityChartData()
                if(this.alarmInfo.sensor_type == 1){
                    await this.getAccChartData()

                    this.lyechartmain = this.$refs.lyechartmain;
                    this.myChart = echarts.init(this.lyechartmain);
                    this.myChart.setOption(this.option);
                    
                    this.AccIntensitychartmain = this.$refs.AccIntensitychartmain;
                    this.myAccIntensityChart = echarts.init(this.AccIntensitychartmain);
                    this.myAccIntensityChart.setOption(this.AccIntensityOption);

                    this.temperatureChartMain = this.$refs.temperatureChartMain;
                    this.myTemperatureChart = echarts.init(this.temperatureChartMain);
                    this.myTemperatureChart.setOption(this.temperatureOption);                

                    this.xyzChartMain = this.$refs.xyzChartMain;
                    this.xyzChart = echarts.init(this.xyzChartMain);
                    this.xyzChart.setOption(this.xyzOption);


                    this.hzChartMain = this.$refs.hzChartMain;
                    this.hzChart = echarts.init(this.hzChartMain);
                    this.hzChart.setOption(this.hz_option);
                }else{
                    this.currentChartMain = this.$refs.currentChartMain;
                    this.myCurrentChart = echarts.init(this.currentChartMain);
                    this.myCurrentChart.setOption(this.currentOption);
                }

            }else{
                if(this.alarmInfo.sensor_type == 1  ){
                    this.myChart.dispose()
                    this.myChart = null
                    this.lyechartmain = null

                    this.myAccIntensityChart.dispose()
                    this.myAccIntensityChart = null
                    this.AccIntensitychartmain = null

                    this.xyzChart.dispose()
                    this.xyzChart = null
                    this.xyzChartMain = null

                    this.hzChart.dispose()
                    this.hzChart = null
                    this.hzChartMain = null

                    this.myTemperatureChart.dispose()
                    this.myTemperatureChart = null
                    this.temperatureChartMain = null
                }else {
                    this.myCurrentChart.dispose()
                    this.myCurrentChart = null
                    this.currentChartMain = null
                }
            }

        },   

        mounted(){
            // this.userName = getStorage("userName")
            // // this.roleValue = this.mutitabsstore.getRole;
            // console.log(this.userName)

            this.roleValue = getStorage("role");
            console.log("############################# : "+ this.roleValue)

        }
    }
</script>

<style lang="scss">

.ly-dialog{
    
    background: url("../../assets/bigscreen/block_bg.jpg") no-repeat;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-color: var(--el-bg-color);
    // padding-top: 200px;
    // .el-dialog__title {
    //     color: black;
    // }
    // .el-form-item__label{
    //     color: black;
    // }
    // .el-textarea__inner{
    //     color: black;
    // }
    // .el-input__inner{
    //     color: black;
    // }
    // .el-dialog__header{
    //     padding-top: 2px;
    // }
    // .el-dialog__title{
    //     padding-left: 1%;
    // }
}


.p-style {  
  color: white; /* 文本颜色 */  
  font-size: 12px; /* 字体大小 */  
  line-height: 1.7; /* 行高 */  
  text-align: left; 
  margin: 0px 0px 0px 50px;
}

.p-style-1 {  
  color: white; /* 文本颜色 */  
  font-size: 14px; /* 字体大小 */  
  line-height: 1.3; /* 行高 */  
  text-align: left; 
  margin: 0px 0px 0px 55px;
}

.p-top-style {  
  color: white; /* 文本颜色 */  
  font-size: 18px; /* 字体大小 */  
  line-height: 1.3; /* 行高 */  
  text-align: left; 
  margin: 0px 0px 5px 50px;
}

</style>